import { Outlet } from 'react-router-dom'

/** Scopes the Mantastic brand theme (gold on white / black) to all /mantastic routes. */
export function MantasticLayout() {
  return (
    <div className="mantastic min-h-full bg-background text-foreground">
      <Outlet />
    </div>
  )
}
